import { render, staticRenderFns } from "./TeamTaxes.vue?vue&type=template&id=4709c8ed&"
import script from "./TeamTaxes.vue?vue&type=script&lang=js&"
export * from "./TeamTaxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports